
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signup/welcome",
      function () {
        return require("private-next-pages/signup/welcome.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/signup/welcome"])
      });
    }
  